import styles from "./FavoriteItemNav.module.scss";
import { Drawer, IconButton, Modal } from "@mui/material";
import { IconPack } from "Explore/Config/Icons";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useMemo, useState } from "react";
import SectionTitle from "Explore/Components/SectionTitle";
import mockData from "./mock-data.json";
import FavoriteFacultyItem from "./FavoriteEntityItem/FavoriteFacultyItem";
import FavoriteInstitutionItem from "./FavoriteEntityItem/FavoriteInstitutionItem";
import FavoriteUnitItem from "./FavoriteEntityItem/FavoriteUnitItem";
import FavoriteVenueItem from "./FavoriteEntityItem/FavoriteVenueItem";
import FavoriteConceptItem from "./FavoriteEntityItem/FavoriteConceptItem";
import {
  getFavoriteConcept,
  getFavoriteFaculty,
  getFavoriteInstitution,
  getFavoriteUnit,
  getFavoriteVenue,
} from "Explore/Services/Favorite";
import { useSelector } from "react-redux";
import { LoadingListCard } from "Explore/Components";
import classNames from "classnames";
import { Empty } from "antd";
import LoginBox from "LandingPage/Components/LoginBox";

const grid = {
  gutter: [8, 8],
  xs: 1,
  sm: 1,
  md: 1,
  lg: 1,
  xl: 1,
  xxl: 1,
};

const FavoriteItemNav = ({ whiteTheme }) => {
  const user = useSelector((state) => state.user.data);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [faculty, setFaculty] = useState({
    data: [],
    total: 0,
    isLoading: true,
  });
  const [institution, setInstitution] = useState({
    data: [],
    total: 0,
    isLoading: true,
  });
  const [unit, setUnit] = useState({ data: [], total: 0, isLoading: true });
  const [venue, setVenue] = useState({ data: [], total: 0, isLoading: true });
  const [concept, setConcept] = useState({
    data: [],
    total: 0,
    isLoading: true,
  });
  const [isOpenLoginDialog, setIsOpenLoginDialog] = useState(false)

  const noData = useMemo(() => {
    return (
      !faculty.isLoading &&
      !institution.isLoading &&
      !unit.isLoading &&
      !venue.isLoading &&
      !concept.isLoading &&
      faculty.data.length === 0 &&
      institution.data.length === 0 &&
      unit.data.length === 0 &&
      venue.data.length === 0 &&
      concept.data.length === 0
    );
  }, [faculty, institution, unit, venue, concept]);

  useEffect(() => {
    if (drawerOpen && !!user) {
      getFavoriteFaculty()
        .then((res) => {
          setFaculty({
            data: res.results,
            total: res.total,
            isLoading: false,
          });
        })
        .catch((err) => {
          setFaculty({
            data: [],
            total: 0,
            isLoading: false,
          });
        });

      getFavoriteInstitution()
        .then((res) => {
          setInstitution({
            data: res.results,
            total: res.total,
            isLoading: false,
          });
        })
        .catch((err) => {
          setInstitution({
            data: [],
            total: 0,
            isLoading: false,
          });
        });

      getFavoriteUnit()
        .then((res) => {
          setUnit({
            data: res.results,
            total: res.total,
            isLoading: false,
          });
        })
        .catch((err) => {
          setUnit({
            data: [],
            total: 0,
            isLoading: false,
          });
        });

      getFavoriteVenue()
        .then((res) => {
          setVenue({
            data: res.results,
            total: res.total,
            isLoading: false,
          });
        })
        .catch((err) => {
          setVenue({
            data: [],
            total: 0,
            isLoading: false,
          });
        });

      getFavoriteConcept()
        .then((res) => {
          setConcept({
            data: res.results,
            total: res.total,
            isLoading: false,
          });
        })
        .catch((err) => {
          setConcept({
            data: [],
            total: 0,
            isLoading: false,
          });
        });
    }

    return () => {
      setFaculty({
        data: [],
        total: 0,
        isLoading: true,
      });
      setInstitution({
        data: [],
        total: 0,
        isLoading: true,
      });
      setUnit({ data: [], total: 0, isLoading: true });
      setVenue({ data: [], total: 0, isLoading: true });
      setConcept({ data: [], total: 0, isLoading: true });
    };
  }, [drawerOpen, user]);

  return (
    <>
      <div
        className={classNames(styles["icon"], {
          [styles["white-theme"]]: whiteTheme,
        })}
        onClick={() => setDrawerOpen(true)}
      >
        {IconPack.bookmark}
      </div>
      <Drawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        anchor="right"
      >
        <div className={styles["drawer"]}>
          <div className={styles["drawer__header"]}>
            <h1 className={styles["drawer__header--title"]}>My Favorites</h1>
            <IconButton onClick={() => setDrawerOpen(false)}>
              <CloseIcon />
            </IconButton>
          </div>

          <div className={styles["drawer__content"]}>
            {!user ? (
              <h3 className={styles["drawer__content--login-text"]}>
                <a onClick={(e) => {
                  e.preventDefault()
                  setIsOpenLoginDialog(true)
                }}>Log In</a> to Use Our Favorite Feature and
                Personalize Your Experience
              </h3>
            ) : noData ? (
              <Empty description="Favorite items will appear here. Add them now!" />
            ) : (
              <>
                <div
                  className={classNames(styles["drawer__content--item"], {
                    [styles["hidden"]]:
                      !faculty.isLoading && !faculty.data.length,
                  })}
                >
                  <SectionTitle
                    title="Faculty members"
                    icon={IconPack.faculty_outline_black}
                    collapsible
                    defaultOpen
                  >
                    <LoadingListCard
                      isLoading={faculty.isLoading}
                      grid={grid}
                      rows={3}
                      componentNum={3}
                      avatar
                      component={
                        <div className={styles["drawer__content--list"]}>
                          {faculty.data.length > 0 &&
                            faculty.data.map((e, i) => (
                              <FavoriteFacultyItem data={e} key={i} />
                            ))}
                        </div>
                      }
                    />
                  </SectionTitle>
                </div>

                <div
                  className={classNames(styles["drawer__content--item"], {
                    [styles["hidden"]]:
                      !institution.isLoading && !institution.data.length,
                  })}
                >
                  <SectionTitle
                    title="Institutions"
                    icon={IconPack.institution_outline_black}
                    collapsible
                    defaultOpen
                  >
                    <LoadingListCard
                      isLoading={institution.isLoading}
                      grid={grid}
                      rows={3}
                      componentNum={3}
                      avatar
                      component={
                        <div className={styles["drawer__content--list"]}>
                          {institution.data.length > 0 &&
                            institution.data.map((e, i) => (
                              <FavoriteInstitutionItem data={e} key={i} />
                            ))}
                        </div>
                      }
                    />
                  </SectionTitle>
                </div>

                <div
                  className={classNames(styles["drawer__content--item"], {
                    [styles["hidden"]]: !unit.isLoading && !unit.data.length,
                  })}
                >
                  <SectionTitle
                    title="Units"
                    icon={IconPack.unit_black}
                    collapsible
                    defaultOpen
                  >
                    <LoadingListCard
                      isLoading={unit.isLoading}
                      grid={grid}
                      rows={3}
                      componentNum={3}
                      avatar
                      component={
                        <div className={styles["drawer__content--list"]}>
                          {unit.data.length > 0 &&
                            unit.data.map((e, i) => (
                              <FavoriteUnitItem data={e} key={i} />
                            ))}
                        </div>
                      }
                    />
                  </SectionTitle>
                </div>

                <div
                  className={classNames(styles["drawer__content--item"], {
                    [styles["hidden"]]: !venue.isLoading && !venue.data.length,
                  })}
                >
                  <SectionTitle
                    title="Venues"
                    icon={IconPack.venue_outline_black}
                    collapsible
                    defaultOpen
                  >
                    <LoadingListCard
                      isLoading={venue.isLoading}
                      grid={grid}
                      rows={3}
                      componentNum={3}
                      avatar
                      component={
                        <div className={styles["drawer__content--list"]}>
                          {venue.data.length > 0 &&
                            venue.data.map((e, i) => (
                              <FavoriteVenueItem data={e} key={i} />
                            ))}
                        </div>
                      }
                    />
                  </SectionTitle>
                </div>

                <div
                  className={classNames(styles["drawer__content--item"], {
                    [styles["hidden"]]:
                      !concept.isLoading && !concept.data.length,
                  })}
                >
                  <SectionTitle
                    title="Concepts"
                    icon={IconPack.concept_outline_black}
                    collapsible
                    defaultOpen
                  >
                    <LoadingListCard
                      isLoading={concept.isLoading}
                      grid={grid}
                      rows={3}
                      componentNum={3}
                      avatar
                      component={
                        <div className={styles["drawer__content--list"]}>
                          {concept.data.length > 0 &&
                            concept.data.map((e, i) => (
                              <FavoriteConceptItem data={e} key={i} />
                            ))}
                        </div>
                      }
                    />
                  </SectionTitle>
                </div>
              </>
            )}
          </div>
        </div>
      </Drawer>
      <Modal open={isOpenLoginDialog} onClose={() => setIsOpenLoginDialog(false)}>
        <div className={styles["login-modal"]}>
          <LoginBox />
        </div>
      </Modal>
    </>
  );
};

export default FavoriteItemNav;
